import { render, staticRenderFns } from "./FloatingBackButton.vue?vue&type=template&id=ecd4b866&scoped=true"
import script from "./FloatingBackButton.vue?vue&type=script&lang=js"
export * from "./FloatingBackButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingBackButton.vue?vue&type=style&index=0&id=ecd4b866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd4b866",
  null
  
)

export default component.exports